import ChatIcon from "../assets/images/icon.chat_logo.svg";
import {Button, TextInput} from "omoplay";
import ArrowTop from "../assets/images/icon.arrow.top.svg";
import {useEffect, useRef, useState} from "react";
import {messageChatStreamGeneration} from "../api/message/volatility-message.api";
import Markdown from "react-markdown";


const MiniAIChatForm = ({histories, id}) => {
    const [messages, setMessages] = useState(histories ?? [])
    const [blockGenerate, setBlockGenerate] = useState(false)
    const [input, setInput] = useState("")
    const scrollRef = useRef(null)
    const [isCommandKeyPressed, setIsCommandKeyPressed] = useState(false)

    function setChatModelMessages(type, message) {
        setMessages((prevMessages) => [...prevMessages, {
            type: type,
            message: message
        }]);
    }

    const streamGeneration = (text, isText = true) => {
        setBlockGenerate(true)
        setInput("")
        // Enter 키를 누르면 메시지를 추가
        if (isText) {
            setChatModelMessages("user", text)
        }

        let curMessage = "";
        setChatModelMessages("model", curMessage)

        const eventSource =  messageChatStreamGeneration(id, text)

        eventSource.onmessage = (event) => {
            const data = event.data
            if (data.includes("AI_CHAT_END")) {
                setBlockGenerate(false)
                eventSource.close();
            } else {
                curMessage += data
                setMessages((prevMessages) => {
                    const updatedMessages = [...prevMessages];
                    updatedMessages[updatedMessages.length - 1] = {
                        type: "model",
                        message: curMessage
                    };
                    return updatedMessages;
                });
            }
        };

        eventSource.onerror = () => {
            setMessages((prevMessages) => {
                curMessage += "오류가 발생했습니다."
                const updatedMessages = [...prevMessages];
                updatedMessages[updatedMessages.length - 1] = {
                    type: "model",
                    message: curMessage
                };
                return updatedMessages;
            });
            setBlockGenerate(false)
            eventSource.close();
        }
    }

    const handleChatKeyDown = (e) => {
        if (e.key === "Shift") {
            setIsCommandKeyPressed(true)
        }
    }

    const handleChatKeyUp = (e) => {
        if (e.key === "Enter" && !isCommandKeyPressed && input.trim() !== "" && !blockGenerate) {
            streamGeneration(input)
            return
        }

        if (e.key === "Shift") {
            setIsCommandKeyPressed(false)
        }
    }

    const handleChatSubmit = () => {
        if (input.trim() !== "" && !blockGenerate) {
            streamGeneration(input)
        }
    }

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [messages]);

    return (
        <div className="flex-1 flex-col bg-white border rounded-[8px] max-h-[900px]">
            <div className="flex-col flex-1 justify-end w-full overflow-scroll">
                <div className="flex-col gap-4 p-8 overflow-scroll" ref={scrollRef}>
                    {messages.map(({type, message}) => {
                        if (type === "model") {
                            return (
                                <>
                                    <div className="flex gap-1">
                                        <img src={ChatIcon} alt="chat-logo" width="20" />
                                        <span className="text-primary font-medium">AI 메시지 봇</span>
                                    </div>
                                    <div className="ml-[20px] whitespace-pre-line">
                                        <Markdown>{message?.replace(/<br\s*\/?>/gi, "\n")}</Markdown>
                                    </div>
                                </>
                            )
                        } else {
                            return (
                                <div className="flex justify-end">
                                    <div className="w-auto bg-depth1 p-20px rounded-[16px]">{message}</div>
                                </div>
                            )
                        }
                    })}
                </div>
                <div className="flex p-[24px] border-t">
                    <div className="flex-1 gap-2">
                        <TextInput placeholder="AI에게 질문 해보세요."
                                   value={input}
                                   onChange={(e) => setInput(e.target.value)}
                                   onKeyDown={handleChatKeyDown}
                                   onKeyUp={handleChatKeyUp}
                                   style={{width: "100%", height: "68px"}}
                        />
                    </div>
                    <div className="relative flex-center-all">
                        <div className="absolute right-0 p-[24px]">
                            <Button disabled={blockGenerate} variants="rounded"
                                    value={<img alt="질문" src={ArrowTop} />}
                                    onClick={handleChatSubmit} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MiniAIChatForm